// extracted by mini-css-extract-plugin
export default {"imageWrapper":"bR-z","hovered":"cR-z","hoverImage":"dR-z","mainImage":"eR-z","imageNoBackground":"fR-z","fullSizeImage":"gR-z"};